import { useQuery } from '@tanstack/react-query';
import { POLL_MS } from '../config';
import { getAlertsSummary } from '../endpoints';
import { queryKeys } from '../queryKeys';
import { queryRetry } from './shared';

// Unread counts and delivery state for the bell (api-surface 2.17).
export function useAlertsSummary(options: { readonly enabled?: boolean; readonly pollMs?: number | false } = {}) {
  return useQuery({
    queryKey: queryKeys.alertsSummary(),
    queryFn: ({ signal }) => getAlertsSummary(signal),
    enabled: options.enabled ?? true,
    refetchInterval: options.pollMs === undefined ? POLL_MS.alertsSummary : options.pollMs,
    refetchIntervalInBackground: false,
    retry: queryRetry,
  });
}
